// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISortVariantSchema {
  /** Значение для варианта сортировки **/
  key: EKey;
  /** Отображаемый текст варианта сортировки  **/
  value: string;
}

export enum EKey {
  /** Заканчивается срок действия **/
  'AboutToEnd' = 'aboutToEnd',
  /** Новые **/
  'NewFirst' = 'newFirst',
  /** Популярные **/
  'Popularity' = 'popularity',
}
